import { IAuthState } from "./interface";

export default <IAuthState> {
	isAuth: false,
	customerSessionExpired: false,
	resetNotificationTrack: false,
	countRefreshRequest: 0
}